import { APIRoute } from '@/modules/utils'

export const Route = (): APIRoute => ({
  method: 'POST',
  path: '/v3/reviews/external/request',
})

export type Body = { content: string; emails: string[]; url: string }

export type Response = never
